(() => {
  let rafId = 0;

  const closeShell = (shell) => {
    const panel = shell?.querySelector('[data-cdb-shell-menu-panel]');
    const toggle = shell?.querySelector('[data-cdb-shell-menu-toggle]');
    if (!panel || !toggle) return;
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  };

  const syncShellHeight = (shell) => {
    if (!shell) return;
    const spacer = shell.nextElementSibling?.matches('[data-cdb-site-shell-spacer]')
      ? shell.nextElementSibling
      : document.querySelector('[data-cdb-site-shell-spacer]');
    const height = Math.ceil(shell.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--cdb-site-shell-height', `${height}px`);
    if (spacer) spacer.style.height = `${height}px`;
    document.body.classList.add('cdb-shell-ready');
  };

  const scheduleSync = (shell) => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => syncShellHeight(shell));
  };

  const updateCompactState = () => {
    document.querySelectorAll('[data-cdb-site-shell]').forEach((shell) => {
      const compact = window.scrollY > 72;
      if (shell.classList.contains('is-compact') !== compact) {
        shell.classList.toggle('is-compact', compact);
        scheduleSync(shell);
      }
    });
  };

  const initializeShell = (shell) => {
    if (!shell || shell.dataset.cdbInitialized === 'true') return;
    shell.dataset.cdbInitialized = 'true';
    syncShellHeight(shell);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => scheduleSync(shell));
      observer.observe(shell);
      shell._cdbResizeObserver = observer;
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cdb-shell-menu-toggle]');
    if (toggle) {
      const shell = toggle.closest('[data-cdb-site-shell]');
      const panel = shell?.querySelector('[data-cdb-shell-menu-panel]');
      if (!panel) return;
      const open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      scheduleSync(shell);
      return;
    }
    document.querySelectorAll('[data-cdb-site-shell]').forEach((shell) => {
      if (!shell.contains(event.target)) closeShell(shell);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-cdb-site-shell]').forEach(closeShell);
  });

  const init = () => {
    document.querySelectorAll('[data-cdb-site-shell]').forEach(initializeShell);
    updateCompactState();
    window.setTimeout(() => {
      document.querySelectorAll('[data-cdb-site-shell]').forEach(syncShellHeight);
    }, 150);
  };

  window.addEventListener('scroll', updateCompactState, { passive: true });
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-cdb-site-shell]').forEach(scheduleSync);
  }, { passive: true });
  window.addEventListener('load', init);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
